import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserStartRouteService } from '../../services/user-start-route.service';

@Component({
  selector: 'app-signed-in-start-redirect',
  template: ''
})
export class SignedInStartRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService,
    private userStartRouteService: UserStartRouteService
  ) {}

  async ngOnInit(): Promise<void> {
    const userId = await this.authService.getCurrentUserUidOnce();
    if (!userId) {
      this.router.navigate(['/signIn']);
      return;
    }

    const startUrl = await this.userStartRouteService.resolveLoginUrl(userId, null);
    this.router.navigateByUrl(startUrl);
  }
}
